import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { io } from 'socket.io-client';
import './styles/global.css';
import './registerServiceWorker'

const currentHost = window.location.hostname;
const isOldDomain = currentHost.includes('toepen-b892c114d7c7.herokuapp.com');

let socket;

if (isOldDomain) {
    console.warn('Running on old domain — not connecting to sockets.');
    alert('We\'ve moved! Please delete this app and go to www.onlinetoepapp.com and add it to your homescreen!');
} else {
    const socketUrl = process.env.VUE_APP_SOCKET_URL || window.location.origin;
    console.log('Connecting to socket at:', socketUrl);
    socket = io(socketUrl);

    // Create Vue app
    const app = createApp(App);

    // Provide the socket globally to all components
    app.provide('socket', socket);

    app.use(router);
    app.mount('#app');
}
